const getDefaultGoogleMapStylesV2 = (): Array<google.maps.MapTypeStyle> => {
  return [
    {
      featureType: 'administrative',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#6d7578',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'geometry.fill',
      stylers: [
        {
          saturation: '-25',
        },
        {
          lightness: '5',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'geometry.stroke',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'landscape.natural',
      elementType: 'geometry.fill',
      stylers: [
        {
          lightness: '60',
        },
        {
          saturation: '0',
        },
        {
          hue: '#00ff65',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'geometry.fill',
      stylers: [
        {
          lightness: '50',
        },
        {
          saturation: '0',
        },
        {
          hue: '#00ff65',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.medical',
      elementType: 'geometry.fill',
      stylers: [
        {
          hue: '#ff2100',
        },
      ],
    },
    {
      featureType: 'poi.medical',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'poi.medical',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#6d7578',
        },
      ],
    },
    {
      featureType: 'poi.medical',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'poi.medical',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#e8705e',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'poi.school',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'poi.school',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#6d7578',
        },
      ],
    },
    {
      featureType: 'poi.school',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'poi.school',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#00b9ff',
        },
        {
          saturation: '-90',
        },
        {
          lightness: '20',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#eceff1',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#8e979e',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'geometry.stroke',
      stylers: [
        {
          lightness: '5',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#6d7578',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'labels.icon',
      stylers: [
        {
          saturation: '-90',
        },
        {
          lightness: '20',
        },
        {
          hue: '#00b9ff',
        },
      ],
    },
    {
      featureType: 'transit.station.airport',
      elementType: 'geometry.fill',
      stylers: [
        {
          lightness: '20',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ddf7ff',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#0086b0',
        },
      ],
    },
  ];
};

export const MINIMUM_ZOOM_LEVEL = 3;

export const getDefaultGoogleMapInitialOptions = (): Readonly<google.maps.MapOptions> => {
  return {
    zoom: 15,
    gestureHandling: 'cooperative',
    disableDefaultUI: true, // Disable all default map UI and explicitly enable some
    zoomControl: true,
    fullscreenControl: true,
    /**
     * Because the google global variable is not ready at the stage,
     * we have to actual value.
     */
    zoomControlOptions: { position: 7.0 }, // google.maps.ControlPosition.RIGHT_CENTER
    styles: getDefaultGoogleMapStylesV2(),
    minZoom: MINIMUM_ZOOM_LEVEL,
    restriction: {
      latLngBounds: {
        north: 50,
        south: -75,
        east: 180,
        west: -180,
      },
    },
    clickableIcons: false,
  };
};

export const GOOGLE_STREETVIEW_DEFAULT_CONFIG = {
  enableCloseButton: false,
  motionTracking: false,
  motionTrackingControl: false,
};

export const centerOfAustralia: Readonly<google.maps.LatLngLiteral> = {
  lat: -25.2744,
  lng: 133.7751,
};
